import { React, useState, useContext, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, Link, useParams } from "react-router-dom";
import { toast } from "react-toastify"; // Use toast instead of alert
import { AuthContext } from "../context/AuthContext"; // Adjust path
import { useSwipeable } from 'react-swipeable';
import GamePageLayout from "./GamePageLayout"; // Adjust path
import styles from '../assets/css/Playground.module.css'; // Import NEW CSS Module

function Playground() {
  const { id } = useParams(); // Game ID
  const [values, setValues] = useState(Array(100).fill("")); // Jodi bets (00-99)
  const [Harufvalues, HarufsetValues] = useState(Array(10).fill("")); // Ander Haruf bets (0-9)
  const [Baharvalues, BaharsetValues] = useState(Array(10).fill("")); // Bahar Haruf bets (0-9)
  const { isAuthenticated, Addbet, Gameinfo } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); // Loading state for submit button
  const [error, setError] = useState(null); // Error state (optional)
  const [GameName, setGameName] = useState("Loading..."); // Game Name state

  // Redirect if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  // Fetch Game Info
  useEffect(() => {
    let isMounted = true;
    if (Gameinfo && id) {
        Gameinfo(id, (res) => {
            if (!isMounted) return;
            if (res.status === 0) {
                message(0, res.msg || "Failed to load game info");
                setGameName("Unknown Game");
            } else if (res.data && res.data.length > 0) {
                setGameName(res.data[0].game_name || "Unknown Game");
            } else {
                 setGameName("Unknown Game");
            }
        });
    } else {
        setGameName("Unknown Game");
        console.error("Gameinfo function or game ID missing.");
    }
     return () => { isMounted = false; };
  }, [id, Gameinfo]);

  // Prevent back navigation (optional)
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handlePopState = (event) => {
        navigate("/dashboard", { replace: true }); // Navigate home/dashboard
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [navigate]);

  // Toast message function
  const message = (status, text) => {
    // return alert(text); // Replaced alert with toast
    const options = {
        position: "top-right", autoClose: 3000, hideProgressBar: false,
        closeOnClick: true, pauseOnHover: true, draggable: true,
        progress: undefined, theme: "dark", // Use dark theme
    };
    if (status === 1) toast.success(text, options);
    else if (status === 0) toast.error(text, options);
    else if (status === 2) toast.warning(text, options);
  };

  // --- Input Handling ---
  const handleInputChange = (index, newValue, purpose) => {
    // Ensure only numbers are entered and handle empty string
    const numericValue = newValue.replace(/[^0-9]/g, '');
    // Allow empty string to clear the input, otherwise parse to int
    const finalValue = numericValue === "" ? "" : parseInt(numericValue, 10);

    if (purpose === "jodi") {
      const updatedValues = [...values];
      updatedValues[index] = finalValue; // Index 0-99
      setValues(updatedValues);
    } else if (purpose === "ander") {
      const AnderupdatedValues = [...Harufvalues];
      AnderupdatedValues[index] = finalValue; // Index 0-9
      HarufsetValues(AnderupdatedValues);
    } else if (purpose === "bahar") {
      const BaharupdatedValues = [...Baharvalues];
      BaharupdatedValues[index] = finalValue; // Index 0-9
      BaharsetValues(BaharupdatedValues);
    }
  };

  // --- Calculations ---
  const calculateSum = (purpose = 'all') => {
    let sum = 0;
    if (purpose === 'all' || purpose === 1) { // Jodi
        // Ensure values are numbers before reducing
        sum += values.reduce((acc, value) => acc + (Number(value) || 0), 0);
    }
    if (purpose === 'all' || purpose === 2) { // Ander
        sum += Harufvalues.reduce((acc, value) => acc + (Number(value) || 0), 0);
    }
    if (purpose === 'all' || purpose === 3) { // Bahar
        sum += Baharvalues.reduce((acc, value) => acc + (Number(value) || 0), 0);
    }
    return sum;
  };

  // --- Bet Submission ---
  const handleBetting = async () => {
    if (isLoading) return; // Prevent double submission

    // Filter out empty values and transform data
    const transformedValuesJodi = values
      .map((value, index) => (Number(value) > 0) ? { bet_numbers: String(index).padStart(2, '0'), bet_money: Number(value), type: 1 } : null)
      .filter(entry => entry !== null);

    const transformedValuesAnderHaruf = Harufvalues
      .map((value, index) => (Number(value) > 0) ? { bet_numbers: String(index), bet_money: Number(value), type: 2 } : null)
      .filter(entry => entry !== null);

    const transformedValuesBaharHaruf = Baharvalues
      .map((value, index) => (Number(value) > 0) ? { bet_numbers: String(index), bet_money: Number(value), type: 3 } : null)
      .filter(entry => entry !== null);

    const mergedArray = [
      ...transformedValuesJodi,
      ...transformedValuesAnderHaruf,
      ...transformedValuesBaharHaruf,
    ];

    if (mergedArray.length === 0) {
      message(0, "Please place at least one bet with an amount greater than 0.");
      return;
    }

    let grandTotal = calculateSum('all');
    if (grandTotal <= 0) {
        message(0, "Total bet amount must be greater than zero.");
        return;
    }

    setIsLoading(true);
    setError(null);

    // ** Keep the setTimeout as requested **
    setTimeout(() => {
        if (Addbet) {
            Addbet(
                id, // game_id
                1, // Assuming session '1' - adjust if needed
                JSON.stringify(mergedArray),
                grandTotal,
                (res) => {
                    setIsLoading(false);
                    if (res.status === 0) {
                        message(0, res.msg || "Failed to place bet.");
                        setError(res.msg || "Failed to place bet.");
                    } else {
                        message(1, res.msg || "Bet placed successfully!");
                        // Prepare receipt data
                        const today = new Date();
                        const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
                        const receiptData = [
                            GameName,
                            formattedDate,
                            mergedArray, // Send the structured bet data
                            grandTotal,
                            'Jodi/Haruf' // Generic type for receipt
                        ];

                        // Clear inputs and navigate to receipt page
                        setValues(Array(100).fill(""));
                        HarufsetValues(Array(10).fill(""));
                        BaharsetValues(Array(10).fill(""));

                        setTimeout(() => {
                            navigate('/receipt', { state: { receiptData } });
                        }, 500); // Shorter delay after success message
                    }
                }
            );
        } else {
             setIsLoading(false);
             message(0, "Betting function not available.");
             setError("Betting function not available.");
        }
    }, 1000); // 1-second delay before initiating the bet process
  };

  // --- Swipe Handlers ---
  const handlers = useSwipeable({
    // Navigate to crossing page on left swipe
    onSwipedLeft: () => navigate(`/crossing/${id}`),
    // Prevent default scroll behavior during swipe
    // trackMouse: true, // Optional: Enable mouse swiping on desktop
    // preventDefaultTouchmoveEvent: true,
  });

  // --- Generate Table Rows ---
  const generateTableRows = (dataArray, purpose) => {
      const rows = [];
      const numRows = purpose === 'jodi' ? 10 : 1; // 10 rows for Jodi, 1 row for Haruf
      const numCols = 10; // 10 columns always

      for (let i = 0; i < numRows; i++) {
          const headers = [];
          const inputs = [];
          for (let j = 0; j < numCols; j++) {
              const number = purpose === 'jodi' ? (i * 10 + j) : j; // 0-99 for Jodi, 0-9 for Haruf
              // Jodi numbers 00-99, Haruf numbers 0-9
              const displayValue = purpose === 'jodi' ? String(number).padStart(2, '0') : String(number);
              const index = number; // Index matches the number

              headers.push(
                  <th key={`th-${purpose}-${number}`} className={styles.tableHeader}>
                      {displayValue}
                  </th>
              );
              inputs.push(
                  <td key={`td-${purpose}-${number}`} className={styles.tableCell}>
                      <input
                          type="number"
                          inputMode="numeric" // Use numeric keyboard on mobile
                          min="0" // Allow 0 but it won't be submitted unless > 0
                          step="1"
                          className={styles.betInput}
                          value={dataArray[index] ?? ""} // Use dataArray passed in
                          onChange={(e) => handleInputChange(index, e.target.value, purpose)}
                          placeholder="0" // Placeholder
                      />
                  </td>
              );
          }
          rows.push(<tr key={`header-row-${purpose}-${i}`}>{headers}</tr>);
          rows.push(<tr key={`input-row-${purpose}-${i}`}>{inputs}</tr>);
      }
      return rows;
  };

  const jodiRows = generateTableRows(values, 'jodi');
  const anderHarufRows = generateTableRows(Harufvalues, 'ander');
  const baharHarufRows = generateTableRows(Baharvalues, 'bahar');

  return (
    <>
      {/* Use themed GamePageLayout */}
      <GamePageLayout handlers={handlers} id={id} GameName={GameName} new_message={null}>
        {/* Game Type Tabs */}
        <div className={styles.gameList}>
          <Link to={`/play/${id}`} className={`${styles.gameLink} ${styles.activeGameLink}`}>
          जोडी/हारुफ़
          </Link>
          <Link to={`/crossing/${id}`} className={styles.gameLink}>
          क्रॉसिंग
          </Link>
          <Link to={`/copypaste/${id}`} className={styles.gameLink}>
          कॉपी पेस्ट
          </Link>
        </div>

        {/* Betting Area */}
        <div className={styles.bettingArea}>
          {/* Jodi Table */}
          <h3 className={styles.tableTitle}>जोडी (00-99)</h3>
          <div className={styles.tableContainer}>
             <table className={styles.betTable}>
               <tbody>{jodiRows}</tbody>
             </table>
          </div>

          {/* Ander Haruf Table */}
          <h3 className={styles.tableTitle}>ANDER हारुफ़ (0-9)</h3>
           <div className={styles.tableContainer}>
             <table className={`${styles.betTable} ${styles.harufTable}`}> {/* Specific class for Haruf */}
               <tbody>{anderHarufRows}</tbody>
             </table>
          </div>


          {/* Bahar Haruf Table */}
          <h3 className={styles.tableTitle}>BAHAR हारुफ़ (0-9)</h3>
           <div className={styles.tableContainer}>
             <table className={`${styles.betTable} ${styles.harufTable}`}> {/* Specific class for Haruf */}
               <tbody>{baharHarufRows}</tbody>
             </table>
          </div>

        </div>

        {/* Summary and Play Button */}
        <div className={styles.summaryContainer}>
          <span className={styles.totalAmount}>
            Total: ₹{calculateSum('all')}
          </span>
          <button
            className={styles.playButton}
            onClick={handleBetting}
            disabled={isLoading} // Disable button when loading
          >
            {isLoading ? 'Processing...' : 'PLAY'}
          </button>
        </div>
        {/* Optional: Display error message */}
        {/* {error && <p className={styles.errorMessage}>{error}</p>} */}
      </GamePageLayout>
    </>
  );
}

export default Playground;
